const API_BASE_URL = "https://allocata-backend.bickerstaffkurt.workers.dev/api";

export async function getToken(user) {
  const response = await fetch(`${API_BASE_URL}/token`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ user }),
  });

  if (!response.ok) {
    throw new Error("Failed to fetch token");
  }

  return response.json();
}